import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  defaultInstallerPayRequest,
  defaultInstallerPaySuccess,
  defaultInstallerPayFailure,
} = createActions(
  'DEFAULT_INSTALLER_PAY_REQUEST',
  'DEFAULT_INSTALLER_PAY_SUCCESS',
  'DEFAULT_INSTALLER_PAY_FAILURE',
);

export function fetchDefaultInstallerPay(pricePatchId) {
  return (dispatch) => {
    dispatch(defaultInstallerPayRequest());
    const query = pricePatchId ? `?price_patch_id=${pricePatchId}` : '';
    return request(`default_installer_pay${query}`)
      .then(({ json }) => dispatch(defaultInstallerPaySuccess(json)))
      .catch(error => dispatch(defaultInstallerPayFailure(error)));
  };
}

const {
  updateDefaultInstallerPayRequest,
  updateDefaultInstallerPaySuccess,
  updateDefaultInstallerPayFailure,
} = createActions(
  'UPDATE_DEFAULT_INSTALLER_PAY_REQUEST',
  'UPDATE_DEFAULT_INSTALLER_PAY_SUCCESS',
  'UPDATE_DEFAULT_INSTALLER_PAY_FAILURE',
);

export function updateDefaultInstallerPay(id, defaultInstallerPayCents) {
  return (dispatch) => {
    dispatch(updateDefaultInstallerPayRequest());
    return request(`default_installer_pay/${id}`, {
      method: 'PATCH',
      body: { patch_item: { default_installer_pay: defaultInstallerPayCents } },
    })
      .then(({ json }) => dispatch(updateDefaultInstallerPaySuccess(json)))
      .catch(error => dispatch(updateDefaultInstallerPayFailure(error)));
  };
}

const {
  bulkUpdateDefaultInstallerPayRequest,
  bulkUpdateDefaultInstallerPaySuccess,
  bulkUpdateDefaultInstallerPayFailure,
} = createActions(
  'BULK_UPDATE_DEFAULT_INSTALLER_PAY_REQUEST',
  'BULK_UPDATE_DEFAULT_INSTALLER_PAY_SUCCESS',
  'BULK_UPDATE_DEFAULT_INSTALLER_PAY_FAILURE',
);

export function bulkUpdateDefaultInstallerPay(items) {
  return (dispatch) => {
    dispatch(bulkUpdateDefaultInstallerPayRequest());
    return request('default_installer_pay/bulk_update', {
      method: 'PATCH',
      body: { patch_items: items },
    })
      .then(({ json }) => dispatch(bulkUpdateDefaultInstallerPaySuccess(json)))
      .catch(error => dispatch(bulkUpdateDefaultInstallerPayFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/default_installer_pay.js